<ng-container *ngIf="cardToken$ | async as cardToken; else addCard">
  <div
    class="ecash-button bg-primary d-flex justify-content-between align-item-center rounded gloss"
    [ngClass]="{
      'bg-frozen': cardToken.Frozen,
    }"
  >
    <div class="card-token-number">
      <ng-container [ngSwitch]="cardToken!.CardType">
        <img class="payment-logo" *ngSwitchCase="1" [src]="'payment-icons/mastercard.svg' | contentAssetImage" />
        <img class="payment-logo" *ngSwitchCase="2" [src]="'payment-icons/amex.svg' | contentAssetImage" />
        <img class="payment-logo visa" *ngSwitchCase="3" [src]="'payment-icons/visa.svg' | contentAssetImage" />
        <img class="payment-logo" *ngSwitchCase="4" [src]="'payment-icons/discover.svg' | contentAssetImage" />
        <img class="payment-logo" *ngSwitchCase="5" [src]="'payment-icons/jcb.svg' | contentAssetImage" />
        <img class="payment-logo" *ngSwitchCase="7" [src]="'payment-icons/dinersclub.svg' | contentAssetImage" />
        <img class="payment-logo" *ngSwitchCase="8" [src]="'payment-icons/unionpay.svg' | contentAssetImage" />
        <div class="payment-logo" *ngSwitchDefault></div>
      </ng-container>
      <span class="ms-3 me-2 praktika-medium"> ({{ cardToken?.CardNumber | creditCardNumber | slice: 15 }}) </span>
      <span class="card-number-expired-date font-size-14 praktika-medium">
        {{ 'member.card.ecash.exp.date' | translate }} {{ cardToken?.ExpiryDate | date: 'MM/YY' }}</span
      >

      <ng-container *ngIf="isExpired(cardToken?.ExpiryDate)">
        <div class="font-size-12 expiried-status ms-4">
          {{ 'ecash.expired' | translate: { fgbdefault: 'EXPIRED' } }}
        </div>
      </ng-container>
    </div>

    <a class="text-white d-flex" [routerLink]="'/payment'">
      <span class="icon material-icons d-flex align-items-center">chevron_right</span>
    </a>
  </div>
</ng-container>

<ng-template #addCard>
  <div class="direct-auth" [routerLink]="'/payment'">
    <div class="btn btn-direct-auth gloss w-100">
      <div class="direct-auth-content">
        <span class="icon material-icons text-white">add_card</span>
        <span class="text-lowercase text-white font-praktika-bold"> {{ 'member.card.add.card' | translate }} </span>
      </div>
    </div>
  </div>
</ng-template>
